import { PositiveInt, schPositiveInt } from '@aloft/toolkit-shared';

export function extractNumberOfUnits(sale: Element): PositiveInt {
  const rentalUnits = Array.from(sale.getElementsByTagName('ROOM_ADJUSTMENT'));
  const unitsFound = rentalUnits.filter((node) => node.getAttribute('TotalRoomCount')).length;

  return schPositiveInt.parse(unitsFound === 0 ? 2 : unitsFound);
}
